import { size } from "lodash";
import { useCallback, useRef, useState } from "react";
import InputField from "../input-field/InputField.jsx";
import styles from "./Pin.module.css";

const Pin = ({ value, onChange, isValid }) => {
  const [isPinShown, setIsPinShown] = useState(false);
  const itemRefs = useRef([]);

  const handleChange = useCallback(
    (e) => {
      const { name: currentName, value: currentValue } = e.target;

      if (!isNaN(e.target.value)) {
        const pinPosition = parseInt(currentName.split("-")[1], 10);

        onChange((prevPin) => {
          return { ...prevPin, [pinPosition]: currentValue };
        });

        if (pinPosition < size(value) && currentValue) {
          itemRefs.current[pinPosition + 1]?.focus();
        }
      }
    },
    [onChange, value],
  );

  const setRef = (index) => (node) => {
    itemRefs.current[index] = node;
  };

  return (
    <div className={styles.pinWrapper}>
      <div className={styles.pin}>
        {Object.values(value).map((code, i) => (
          <InputField
            key={i}
            required
            autoComplete="off"
            ref={setRef(i)}
            value={code || ""}
            onChange={handleChange}
            maxLength={1}
            type={isPinShown ? "text" : "password"}
            name={`pin-${i}`}
            id={`pin-${i}`}
            isValid={isValid}
            className={styles.inputField}
            center={true}
          />
        ))}
      </div>
      <div className={styles.pinActions}>
        <button
          type="button"
          className={styles.showHideTextButton}
          onClick={() => setIsPinShown((prev) => !prev)}
        >
          {isPinShown ? "Hide" : "Show"}
        </button>
      </div>
    </div>
  );
};

export default Pin;
